import { createFileRoute } from "@tanstack/react-router";

// Mục Ảnh thẻ của QC chụp ảnh (QĐ 0521).
export const Route = createFileRoute("/_app/qc-desk/anh-the")({});
